export function normalizeTableauFilterKind(kindRaw: any): string {
  return String(kindRaw ?? '').trim().toLowerCase()
}

export function isHideDisplayFilter(filter: any): boolean {
  if (!filter || typeof filter !== 'object') return false
  return normalizeTableauFilterKind((filter as any)?.kind).startsWith('hide')
}

/**
 * PR4 (compiler-rewrite): the canonical, semantics-only predicate for
 * "does this authored Tableau filter participate in SQL lowering?".
 *
 * Legacy TS code (`src/tableau/worksheetQueryBuilder.ts::
 * shouldSkipSqlFilter`) inlines an `isHideDisplayFilter` check and
 * elides these filters during WHERE-clause construction; the runtime
 * (`src/worker/worker.ts`, `src/tableau/crosstabLayout.ts`) then
 * applies them as post-execution row predicates. The typed-spec
 * contract makes this explicit via `TypedFilter.hideDisplay`
 * (`src/tableau/worksheetCompilerTyped.ts`), which both the TS
 * typed compiler and the Rust compiler
 * (`query_builder/src/worksheet_compiler/typed_spec.rs::TypedFilter`)
 * honor. Use this helper anywhere authoring-level Tableau filters
 * are lowered to the typed-spec IR.
 */
export function shouldLowerTableauFilterToSql(filter: any): boolean {
  return !isHideDisplayFilter(filter)
}
